// extracted by mini-css-extract-plugin
export default {"root":"ItemRow__root--3vBfh","icon":"ItemRow__icon--2vJXX"};